import { Box, Stack, useMediaQuery } from '@mui/material';
import { PageOuterContainer } from '../../../../root-components/layouts/page-outer-container'
import { SettingsMobileNavbar } from '../../../../root-components/navigation/settings-mobile-navbar';
import gaiaTheme from '../../../../root-components/theme';
import { PageHeading } from '../../../presentation-components/display-elements-components/page-heading';
import { useNavigate } from 'react-router-dom';
import { TableDisplay } from '../../../presentation-components/miscellaneous-components/table-display';
import { LoadingPage } from '../../loading-page';
import { IHeadCell } from '../../../../shared/interfaces/table-display.model';
import ConversionSourceService from '../../../../shared/services/conversion-source/conversion-source.service';
import { useEffect, useState } from 'react';
import { IConversionSource } from '../../../../shared/services/conversion-source/conversion-source.model';

export const SettingsConversionSourcePage = () => {
  const navigate = useNavigate();
  //Services
  const conversionSourceService = new ConversionSourceService();
  //State
  const [conversionSources, setConversionSources] = useState<IConversionSource[]>([]);
  //Table State
  const [selected, setSelected] = useState<string[]>([]);
  const [inputPage, setInputPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [change, setChange] = useState<number>(0);
  const [orderBy, setOrderBy] = useState<string>();
  const [order, setOrder] = useState<'asc' | 'desc'>();
  //Loading State
  const [hasComponentMounted, setHasComponentMounted] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)

  //Layout
  const isMobileMode = useMediaQuery(gaiaTheme.breakpoints.down('md'));

  useEffect(() => {
    conversionSourceService.getAllWithPagination(inputPage, perPage, orderBy, order, 'active=true')
      .then(response => {
        setIsLoading(false);
        setConversionSources(response.rows);
        setTotalRecords(response.count);
      })
      .catch(error => {
        setIsLoading(false);
        console.error(error);
      });
  }, [inputPage, perPage, change, orderBy, order]);

  useEffect(() => {
    if (hasComponentMounted) {
      if (inputPage === 0) {
        setChange(change + 1)
      } else {
        setInputPage(0)
      }
    }
    setHasComponentMounted(true)
  }, [order, orderBy])

  //Table Contents
  const headCells: IHeadCell[] = [
    { id: 'source', numeric: false, label: 'Source', sortable: true, isHeading: true },
    { id: 'country', numeric: false, label: 'Country', sortable: true },
    { id: 'conversionType', numeric: false, label: 'Conversion Type', sortable: false },
  ]

  const rows = conversionSources.map(conversionSource => {
    return {
      id: conversionSource.id,
      source: conversionSource.source,
      conversionType: conversionSource.conversionType === 'spendBasedConversion' ? 'Spend Based Conversion Factors' : conversionSource.conversionType === 'squareFootConversion' ? 'Square Foot Conversion Factors' : 'General Conversion Factors',
      country: conversionSource.country ? (
        <Stack display='flex' flexDirection='row' alignItems='center' gap={1}>
          <img
            loading="lazy"
            width="20"
            src={conversionSource.country.imageUrl}
            alt={`${conversionSource.country.name} flag`}
          />
          {conversionSource.country.name}
        </Stack>
      ) : null,
    }
  });


  const handleSelected = (selectedRowId: string[]) => {
    if (selectedRowId[0] !== undefined) {
      navigate(`/settings/company-settings/conversion-factors/${selectedRowId[0]}`)
    }
  }

  const handleOrderChange = (newOrderBy: string, newOrder: 'asc' | 'desc') => {
    setOrderBy(newOrderBy);
    setOrder(newOrder);
  };

  return (
    <PageOuterContainer>
      {isMobileMode &&
        <Box sx={{ pb: 4 }}>
          <SettingsMobileNavbar />
        </Box>}
      <PageHeading
        title='Conversion Factors'
        hasTabs={false} />
      <LoadingPage pageReady={!isLoading}>
        <TableDisplay
          onOrderChange={handleOrderChange}
          headCells={headCells}
          rows={rows}
          handleSelected={handleSelected}
          selected={selected}
          setSelected={setSelected}
          selectByIcon={false}
          inputPage={inputPage}
          setInputPage={setInputPage}
          totalRecords={totalRecords}
          perPage={perPage}
          setPerPage={setPerPage}
        />
      </LoadingPage>
    </PageOuterContainer>
  )
}